
import React, { PureComponent } from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Shapes } from '../../models/entities';
import AchSortableHeader from '../../containers/tables/AchSortableHeader';
import SelectableRow from './SelectableRow';

class AchTable extends PureComponent {
  render() {
    const { achs, onSelectChange, selectedId } = this.props;
    if (achs.lastName > 0) {
    }
    return (
      <Table bordered responsive>
        <thead>
          <tr>
            <AchSortableHeader fieldName="id">#</AchSortableHeader>
            <AchSortableHeader fieldName="alias">Alias</AchSortableHeader>
            <AchSortableHeader fieldName="accountNumber">Account Number (last 4)</AchSortableHeader>
            <AchSortableHeader fieldName="routingNumber">Routing Number (last 4)</AchSortableHeader>
            <AchSortableHeader fieldName="firstName">First Name</AchSortableHeader>
            <AchSortableHeader fieldName="lastName">Last Name</AchSortableHeader>
            <AchSortableHeader fieldName="active">Active</AchSortableHeader>
          </tr>
        </thead>
        <tbody>
          {achs.length > 0
            ? achs.map((ach) => (
              <SelectableRow
                onSelectChange={onSelectChange}
                selected={ach.id === selectedId}
                rowId={ach.id}
                key={ach.id}
              >
                <td>{ach.id}</td>
                <td>{ach.alias}</td>
                <td>{ach.accountNumber}</td>
                <td>{ach.routingNumber}</td>
                <td>{ach.contactInfo.firstName}</td>
                <td>{ach.contactInfo.lastName}</td>
                <td><input type="checkbox" checked={ach.active} disabled /></td>
              </SelectableRow>
            )) : (
              <tr>
                <td colSpan={8}>No records.</td>
              </tr>
            )}
        </tbody>
      </Table>
    );
  }
}

AchTable.propTypes = {
  achs: PropTypes.arrayOf(Shapes.ACH),
  selectedId: PropTypes.number,
  onSelectChange: PropTypes.func.isRequired,
};

AchTable.defaultProps = {
  achs: [],
  selectedId: undefined,
};

export default AchTable;
